import type { PuzzleResult } from './PuzzleGenerator';

// Color palette — indices map to CSS colors
const COLORS = [
  '#FF6B6B', '#4ECDC4', '#60A5FA', '#FFE66D',
  '#A78BFA', '#FB923C', '#34D399', '#F472B6',
];

export function generateColorSequence(complexity: number, subtlety: number): PuzzleResult {
  const length = Math.min(complexity, 8);

  // Generate a reference sequence
  const reference: number[][] = [];
  for (let i = 0; i < length; i++) {
    const colorIdx = Math.floor(Math.random() * Math.min(4 + Math.floor(subtlety * 4), COLORS.length));
    reference.push([colorIdx]);
  }

  // Decide if this output has an error (~60% chance of error)
  const hasError = Math.random() < 0.75;

  let output: number[][];
  if (hasError) {
    output = reference.map(r => [...r]);
    // Pick a random position to mutate
    const mutPos = Math.floor(Math.random() * length);
    const original = output[mutPos][0];

    if (subtlety < 0.3) {
      // Easy: swap to a very different color
      let newColor: number;
      do {
        newColor = Math.floor(Math.random() * Math.min(4, COLORS.length));
      } while (newColor === original);
      output[mutPos][0] = newColor;
    } else if (subtlety < 0.7) {
      // Medium: swap to an adjacent color in the palette
      const offset = Math.random() < 0.5 ? 1 : -1;
      output[mutPos][0] = (original + offset + COLORS.length) % COLORS.length;
    } else {
      // Hard: swap two adjacent elements (subtle reordering)
      const swapWith = Math.min(mutPos + 1, length - 1);
      if (swapWith !== mutPos) {
        [output[mutPos], output[swapWith]] = [output[swapWith], output[mutPos]];
      } else {
        // Can't swap, change color slightly
        output[mutPos][0] = (original + 1) % COLORS.length;
      }
    }
  } else {
    output = reference.map(r => [...r]);
  }

  return {
    reference,
    output,
    hasError,
    referenceLabel: 'Expected Sequence',
    outputLabel: 'Agent Output',
  };
}

// Export the color palette for rendering
export { COLORS as COLOR_PALETTE };
